import React from 'react';
import { FrontOverlay, type FrontOverlayMode } from './FrontOverlay';

type Props = {
  open: boolean;
  onClose: () => void;
  mode?: FrontOverlayMode;
  src: string;
  title: string;
  loading?: boolean;
  iframeRef?: React.RefObject<HTMLIFrameElement | null>;
  onLoad?: () => void;
  panelClassName?: string;
  wrapperClassName?: string;
  iframeTitle?: string;
  closeLabel?: string;
  openPageHref?: string;
  openPageLabel?: string;
  footerHref?: string;
  footerLabel?: string;
};

export const FrontIframeOverlay: React.FC<Props> = ({
  open,
  onClose,
  mode = 'modal',
  src,
  title,
  loading = false,
  iframeRef,
  onLoad,
  panelClassName = '',
  wrapperClassName = '',
  iframeTitle,
  closeLabel = 'Close',
  openPageHref = '',
  openPageLabel = '',
  footerHref = '',
  footerLabel = '',
}) => {
  return (
    <FrontOverlay open={open} mode={mode} onClose={onClose} panelClassName={panelClassName}>
      <div className={`ips-frontfw-iframe-overlay ${wrapperClassName}`.trim()}>
        <header className="ips-frontfw-iframe-overlay__header">
          <h3>{title}</h3>
          <div className="ips-frontfw-iframe-overlay__actions">
            {openPageHref ? (
              <a href={openPageHref} className="ips-frontfw-iframe-overlay__link">
                {openPageLabel}
              </a>
            ) : null}
            <button type="button" aria-label={closeLabel} onClick={onClose}>
              ×
            </button>
          </div>
        </header>
        <div className="ips-frontfw-iframe-overlay__body">
          {loading ? <div className="ips-frontfw-iframe-overlay__loading" /> : null}
          <iframe
            ref={iframeRef}
            className="ips-frontfw-iframe-overlay__iframe"
            src={src}
            title={iframeTitle || title}
            onLoad={onLoad}
          />
        </div>
        {footerHref && footerLabel ? (
          <footer className="ips-frontfw-iframe-overlay__footer">
            <a href={footerHref}>{footerLabel}</a>
          </footer>
        ) : null}
      </div>
    </FrontOverlay>
  );
};
